import { z } from 'zod';
/**
 * Notification-side `app_settings` keys. Separate file from `llm-settings.ts`
 * because the axis is different (what we NOTIFY about, not how we call the LLM),
 * but the schema idiom is deliberately identical — see the WRITE/READ boundary
 * rationale on {@link AutoTranslateSetting} in `llm-settings.ts`.
 */
export const TELEGRAM_FOLLOWUP_PING_KEY = 'notifications.telegram_followup_ping';
/** WRITE boundary for {@link TELEGRAM_FOLLOWUP_PING_KEY} — `.strict()` rejects typos
 *  at write time rather than storing them. Mirrors `SuppressNonCustomerSetting`. */
export const TelegramFollowupPingSetting = z.object({ enabled: z.boolean() }).strict();
/** READ boundary for {@link TELEGRAM_FOLLOWUP_PING_KEY}: additive unknown fields from a
 *  newer writer pass through; a non-boolean / missing `enabled` fails parse → fail-safe
 *  OFF, which is also the ROLLOUT default (no ping = today's behaviour, so a missing
 *  row and a corrupt row both mean «ничего не изменилось»).
 *  Mirrors `SuppressNonCustomerStoredSetting`. */
export const TelegramFollowupPingStoredSetting = z.object({ enabled: z.boolean() }).passthrough();
//# sourceMappingURL=notification-settings.js.map